<template>
    <footer :style="'background:url(/static/img/world-map.png) center no-repeat #131314'">
    <section class="container" >
        <aside>
            <figure>
                <img :src="'/static/img/shamal-logo-2.png'" width="120" alt="">
            </figure>
        </aside>
        <p>
            &copy;2020 Shamal Communications. All rights reserved.
        </p>
    </section>
</footer>

</template>
<script>
    export default{
        props: [],
    }
</script>

<style>

footer {
    padding: 40px;
    margin: 0;
}
footer img {
    filter: invert(1) grayscale(1);
}

footer p {
    color: #eee;
    font-size: 14px;
}
</style>